module.exports = __webpack_public_path__ + "img/Phone_01.bb0c5e37.jpg";